// «Страна телефона» из профиля юзера (ISO 3166-1 alpha-2 от TDLib).
// Названия — через Intl.DisplayNames на русском; флаг — regional indicators.
// Здесь нет таймстампов/таймзон, поэтому lib/datetime.ts не задействован:
// registrationMonth — календарный "YYYY-MM" без привязки к поясу.

const REGION_NAMES = (() => {
  try {
    return new Intl.DisplayNames(["ru"], { type: "region" });
  } catch {
    return null;
  }
})();

const ISO_RE = /^[A-Z]{2}$/;

export const countryFlag = (iso: string): string => {
  const code = iso.trim().toUpperCase();
  if (!ISO_RE.test(code)) {
    return "";
  }
  const A = 0x1f1e6;
  return (
    String.fromCodePoint(A + code.charCodeAt(0) - 65) +
    String.fromCodePoint(A + code.charCodeAt(1) - 65)
  );
};

/** «🇵🇹 Португалия»; при неизвестном коде — просто код. */
export const countryLabel = (iso: string): string => {
  const code = iso.trim().toUpperCase();
  if (!ISO_RE.test(code)) {
    return iso;
  }
  let name: string | undefined;
  try {
    name = REGION_NAMES?.of(code) ?? undefined;
  } catch {
    name = undefined;
  }
  const flag = countryFlag(code);
  return [flag, name && name !== code ? name : code].filter(Boolean).join(" ");
};

const MONTHS_RU = [
  "январь",
  "февраль",
  "март",
  "апрель",
  "май",
  "июнь",
  "июль",
  "август",
  "сентябрь",
  "октябрь",
  "ноябрь",
  "декабрь"
];

/** Короткая подпись таймера автоудаления: 86400 → «1д», 3600 → «1ч». */
export const formatAutoDeleteShort = (seconds: number): string => {
  if (seconds >= 86_400) {
    return `${Math.round(seconds / 86_400)}д`;
  }
  if (seconds >= 3_600) {
    return `${Math.round(seconds / 3_600)}ч`;
  }
  return `${Math.max(1, Math.round(seconds / 60))}м`;
};

/** "2024-05" → «май 2024»; невалидное значение возвращается как есть. */
export const formatRegistrationMonth = (raw: string): string => {
  const match = raw.trim().match(/^(\d{4})-(\d{2})$/);
  if (!match) {
    return raw;
  }
  const monthIndex = Number(match[2]) - 1;
  const month = MONTHS_RU[monthIndex];
  return month ? `${month} ${match[1]}` : raw;
};
